import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../contexts/ThemeContext';
import LanguageSwitcher from './LanguageSwitcher';
import ThemeToggle from './ThemeToggle';
import '../styles/Navbar.css';
import whiteLogo from '../assets/images/white_logo.png';
import blackLogo from '../assets/images/black_logo.png';

const Navbar = () => {
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  // Logo logic: 
  // - Not scrolled: always white logo (on hero background)
  // - Scrolled + light mode: black logo
  // - Scrolled + dark mode: white logo
  const getLogo = () => {
    if (!isScrolled) return whiteLogo;
    return isDarkMode ? whiteLogo : blackLogo;
  };

  return (
    <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''} ${isDarkMode ? 'dark-mode' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-logo" onClick={() => scrollToSection('home')}>
          <img
            src={getLogo()}
            alt="Roua Logo"
            className="logo-image"
          />
        </div>

        <ul className={`navbar-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          <li onClick={() => scrollToSection('home')}>{t('nav.home')}</li>
          <li onClick={() => scrollToSection('about')}>{t('nav.about')}</li>
          <li onClick={() => scrollToSection('projects')}>{t('nav.projects')}</li>
          <li onClick={() => scrollToSection('contact')}>{t('nav.contact')}</li>
        </ul>

        <div className="navbar-actions">
          <ThemeToggle isScrolled={isScrolled} />
          <LanguageSwitcher isScrolled={isScrolled} isDarkMode={isDarkMode} />
          <div 
            className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;